import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface LogoState {
  companyLogo: string | null;
  companyName: string | null;
}

const initialState: LogoState = {
  companyLogo: localStorage.getItem('companyLogo') || null,
  companyName: localStorage.getItem('companyName') || null,
};

const logoSlice = createSlice({
  name: 'logo',
  initialState,
  reducers: {
    setCompanyLogo: (state, action: PayloadAction<string | null>) => {
      state.companyLogo = action.payload;
    },
    setCompanyName: (state, action: PayloadAction<string | null>) => {
      state.companyName = action.payload;
    },
    clearCompanyLogo: (state) => {
      state.companyLogo = null;
      state.companyName = null;
    },
  },
});

export const { setCompanyLogo, setCompanyName, clearCompanyLogo } = logoSlice.actions;
export default logoSlice.reducer;
